var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7332 23.04C16.4266 24.3067 14.9999 24.1067 13.6266 23.5067C12.1732 22.8933 10.8399 22.8667 9.30656 23.5067C7.38656 24.3333 6.37323 24.0933 5.22656 23.04C-1.28011 16.3333 -0.320107 6.12 7.06656 5.74667C8.86656 5.84 10.1199 6.73333 11.1732 6.81333C12.7466 6.49333 14.2532 5.57333 15.9332 5.69333C17.9466 5.85333 19.4666 6.65333 20.4666 8.09333C16.3066 10.5867 17.2932 16.0667 21.1066 17.6C20.3466 19.6 19.3599 21.5867 17.7199 23.0533L17.7332 23.04ZM11.0399 5.66667C10.8399 2.69333 13.2532 0.24 16.0266 0C16.4132 3.44 12.9066 6 11.0399 5.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplelogo);
export default __webpack_public_path__ + "static/media/applelogo.d8f0048d408a93ab4981b18c9b2f0a20.svg";
export { ForwardRef as ReactComponent };